import {
	HomeOutlined,
	UserOutlined,
	UsergroupAddOutlined,
	SettingOutlined,
	FileDoneOutlined,
	TruckOutlined,
	SnippetsOutlined,
	DollarCircleOutlined,
	BankOutlined,
	TeamOutlined,
	SolutionOutlined,
	WalletOutlined,
	AreaChartOutlined,
	AccountBookOutlined,
	DashboardOutlined,
	FileTextOutlined,
	MailOutlined,
	AuditOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
	PermissaoAuditoriaEnum,
	PermissaoGrupoUsuarioEnum,
	PermissaoUsuarioEnum,
	PermissaoGrupoSeguroEnum,
	PermissaoTipoVeiculoEnum,
	PermissaoEspecieVeiculoEnum,
	PermissaoComposicaoVeiculoEnum,
	PermissaoTipoSinistroEnum,
	PermissaoTipoDespesaSinistroEnum,
	PermissaoEstadoEnum,
	PermissaoCidadeEnum,
	PermissaoIntegranteEnum,
	PermissaoVistoriadorEnum,
	PermissaoSinistroEnum,
	PermissaoModeloVeiculoEnum,
	PermissaoMotoristaEnum,
	PermissaoPaisEnum,
	PermissaoVeiculoEnum,
	PermissaoDespesaSinistroEnum,
	PermissaoVendedorEnum,
	PermissaoPenalizacaoEnum,
	PermissaoMarcaVeiculoEnum,
	PermissaoVistoriaEnum,
	PermissaoContaPagarEnum,
	PermissaoContaReceberEnum,
	PermissaoTaxaAdministracaoEnum,
	PermissaoDashboardFinanceiroEnum,
	PermissaoConfiguracaoFinanceiraEnum,
	PermissaoRelatorioEnum,
	PermissaoDashboardOperacionalEnum,
	PermissaoDashboardEnum,
	PermissaoCentralEnvioEnum,
} from "enum/permissao-enum";

const dashBoardNavTree = [
	{
		key: "dashboard",
		path: `${APP_PREFIX_PATH}/dashboard`,
		title: "dashboard",
		icon: HomeOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoDashboardEnum.VISUALIZAR,
	},
	{
		key: "dashboard-financeiro",
		path: `${APP_PREFIX_PATH}/dashboard-financeiro`,
		title: "dashboard-financeiro",
		icon: AreaChartOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoDashboardFinanceiroEnum.VISUALIZAR,
	},
	{
		key: "dashboard-operacional",
		path: `${APP_PREFIX_PATH}/dashboard-operacional`,
		title: "Dashboard Operacional",
		icon: DashboardOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoDashboardOperacionalEnum.VISUALIZAR,

	},
	{
		key: "lista-integrante",
		path: `${APP_PREFIX_PATH}/lista-integrante`,
		title: "lista-integrante",
		icon: TeamOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoIntegranteEnum.VISUALIZAR,
	},
	{
		key: "lista-veiculo",
		path: `${APP_PREFIX_PATH}/lista-veiculo`,
		title: "lista-veiculo",
		icon: TruckOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoVeiculoEnum.VISUALIZAR,
	},
	{
		key: "lista-integrante-veiculo",
		path: `${APP_PREFIX_PATH}/lista-integrante-veiculo`,
		title: "lista-integrante-veiculo",
		icon: SolutionOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoIntegranteEnum.VISUALIZAR,
	},
	{
		key: "lista-veiculo-precificacao",
		path: `${APP_PREFIX_PATH}/lista-veiculo-precificacao`,
		title: "lista-veiculo-precificacao",
		icon: TruckOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoVeiculoEnum.CRIAR,
		indexNotificacoes: "veiculosPrecificacao",
	},
	{
		key: "lista-veiculo-pre-cadastro",
		path: `${APP_PREFIX_PATH}/lista-veiculo-pre-cadastro`,
		title: "Veículos em Pré-cadastro",
		icon: TruckOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoVeiculoEnum.CRIAR,
		indexNotificacoes: "veiculosPreCadastro",
	},
	{
		key: "lista-veiculo-com-pendencias",
		path: `${APP_PREFIX_PATH}/lista-veiculo-com-pendencias`,
		title: "Veículos com Pendências",
		icon: TruckOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoVeiculoEnum.CRIAR,
		indexNotificacoes: "veiculosComPendencias",
	},
	{
		key: "lista-vistoria",
		path: `${APP_PREFIX_PATH}/lista-vistoria`,
		title: "lista-vistoria",
		icon: FileDoneOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoVistoriaEnum.VISUALIZAR,
		indexNotificacoes: "vistoriasPendentes",
	},
	{
		key: "lista-sinistros",
		path: `${APP_PREFIX_PATH}/lista-sinistros`,
		title: "Sinistros",
		icon: SnippetsOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoSinistroEnum.VISUALIZAR,
	},
	{
		key: "lista-contas-pagar",
		path: `${APP_PREFIX_PATH}/lista-contas-pagar`,
		title: "Contas a Pagar",
		icon: DollarCircleOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoContaPagarEnum.VISUALIZAR,
	},
	{
		key: "lista-contas-receber",
		path: `${APP_PREFIX_PATH}/lista-contas-receber`,
		title: "Contas a Receber",
		icon: WalletOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoContaReceberEnum.VISUALIZAR,
	},
	{
		key: "configuracao-financeira",
		path: `${APP_PREFIX_PATH}/configuracao-financeira`,
		title: "Configuração Financeira",
		icon: AccountBookOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoConfiguracaoFinanceiraEnum.VISUALIZAR,
	},
	{
		key: "lista-juridico",
		path: `${APP_PREFIX_PATH}/lista-juridico`,
		title: "lista-juridico",
		icon: BankOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoSinistroEnum.VISUALIZAR,
	},
	{
		key: "lista-usuarios",
		path: `${APP_PREFIX_PATH}/lista-usuarios`,
		title: "lista-usuarios",
		icon: UserOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoUsuarioEnum.VISUALIZAR,
	},
	{
		key: "lista-grupos-usuario",
		path: `${APP_PREFIX_PATH}/lista-grupos-usuario`,
		title: "lista-grupos-usuario",
		icon: UsergroupAddOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoGrupoUsuarioEnum.VISUALIZAR,
	},
	{
		key: "ferramentas",
		path: `${APP_PREFIX_PATH}/ferramentas`,
		title: "Ferramentas",
		icon: SettingOutlined,
		breadcrumb: false,
		submenu: [],
	},
	{
		key: "relatorios",
		path: `${APP_PREFIX_PATH}/relatorios`,
		title: "Relatórios",
		icon: FileTextOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoRelatorioEnum.VISUALIZAR,
	},
	{
		key: "central-envios",
		path: `${APP_PREFIX_PATH}/central-envios`,
		title: "Central de Envios",
		icon: MailOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoCentralEnvioEnum.VISUALIZAR,
	},
	{
		key: "lista-auditoria-registro",
		path: `${APP_PREFIX_PATH}/lista-auditoria-registro`,
		title: "Auditoria",
		icon: AuditOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoAuditoriaEnum.VISUALIZAR,
	},
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
